<script>
  // TODO: Nav background color transition is choppy. My assertion is that the event handler continues to fire after its condition has been met, making the color state continue to change, causing animation jank.

  import { heroHeight } from "./utils/stores.js";
  import { fade } from "svelte/transition";
  import { onMount } from "svelte";

  onMount(() => {
    changeNav();
  });

  let scrollPosition;

  let menuState = "closed";
  function toggleMenu() {
    menuState === "closed" ? (menuState = "opened") : (menuState = "closed");
  }

  let navTheme = "dark";
  function changeNav() {
    scrollPosition > $heroHeight ? (navTheme = "light") : (navTheme = "dark");
  }
  function debounce(func, wait, immediate) {
    var timeout;

    return function executedFunction() {
      var context = this;
      var args = arguments;

      var later = function () {
        timeout = null;
        if (!immediate) func.apply(context, args);
      };

      var callNow = immediate && !timeout;

      clearTimeout(timeout);

      timeout = setTimeout(later, wait);

      if (callNow) func.apply(context, args);
    };
  }
</script>

<style>
  a {
    text-decoration: none;
  }
  nav {
    position: relative;
    align-items: center;
  }
  .media-kit-button {
    width: 194px;
    height: 47px;
    background: #fff;
    border: none;
    border-radius: 15px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: 0;
    padding: 0 23px;
    color: #1b2225;
    font-weight: 800;
    letter-spacing: 2px;
  }
  .media-kit-button img {
    margin: 0 auto;
  }
  .casey-logo-container {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .invert-color {
    -webkit-filter: invert(1);
    filter: invert(1);
  }
  .social-media-icon {
    filter: invert(0);
    transition: filter 0.5s ease-out;
  }

  .nav-wrapper-container {
    /* background-color: #1B2225; */
    position: fixed;
    top: 0;
    z-index: 100;
    width: 100%;
    transition: background-color 0.2s ease-out;
  }
  .nav-container {
    margin: 0 5%;
    /* background-color: #1B2225; */
    overflow: hidden;
    transition: background-color 0.2s ease-out;
  }
  .nav-inner-container {
    margin: 0 auto;
    max-width: 1210px;
    /* background-color: #1B2225; */
    width: 100%;
    margin: 0 auto;
    transition: background-color 0.2s ease-out;
  }
  .nav-inner-container header {
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
  }
  .nav-inner-container nav {
    display: flex;
    width: 100%;
    height: 97px;
    margin: 0 auto;
  }
  .nav-placeholder {
    height: 97px;
    width: 100%;
  }
  #mobile-cc-logo {
    display: none;
  }
  .nav-social-links {
    display: flex;
    width: 100%;
    justify-content: flex-end;
    flex-direction: row;
  }

  .nav-social-links a {
    align-items: center;
    margin: auto 5% auto 0;
  }

  .nav-hamburger-menu {
    display: none;
  }

  .ham {
    position: relative;
    width: 40px;
    height: 40px;
    cursor: pointer;
    padding: 0;
    border: none;
    outline: none;
    font: inherit;
    color: inherit;
    background: none;
    display: flex;
    margin: auto;
    display: none;
  }
  .ham_line {
    position: absolute;
    left: 5px;
    width: 22px;
    height: 2px;
    background-color: #1b2225;
  }
  .ham_line1 {
    top: 11px;
    transition: transform 0.3s;
  }
  .ham_line2 {
    top: 18px;
  }
  .ham_line3 {
    top: 25px;
    transition: transform 0.3s;
  }

  .opened .ham_line1 {
    transform: rotate(45deg);
    top: 20px;
  }
  .opened .ham_line2 {
    width: 0px;
  }
  .opened .ham_line3 {
    transform: rotate(-45deg);
    top: 20px;
  }

  @media only screen and (max-width: 1024px) {
    .nav-inner-container nav,
    .nav-placeholder {
      height: 87px;
    }
    .nav-social-links a:last-child {
      margin: auto 0;
    }
    .media-kit-button {
      display: none;
    }
  }
  @media only screen and (max-width: 640px) {
    nav {
      align-items: baseline;
    }
    .nav-inner-container nav,
    .nav-placeholder {
      height: 64px;
    }
    nav {
      justify-content: space-between;
    }
    .nav-social-links {
      display: none;
    }
    .casey-logo-container {
      display: none;
    }
    .ham {
      display: block;
      margin: auto 0;
    }
    #mobile-cc-logo {
      display: block;
      margin: auto 0;
      z-index: 100;
      height: 29px;
    }
    .nav-social-links a {
      margin: 0;
    }
    .nav-social-links a:last-child {
      margin: 0;
    }
    .nav-social-links a img {
      margin: 4vh 0;
    }

    .nav-social-links.opened {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      background: #1b2225e6;
      height: 100vh;
      position: fixed;
      left: 0;
    }
    .nav-social-links.opened.invert-color {
      background: #000000e6;
    }

    .social-media-icon {
      width: 54px;
    }
  }
</style>

<svelte:window
  bind:scrollY={scrollPosition}
  on:scroll={debounce(changeNav, 100)} />

<div class="nav-placeholder" />
<!-- style="background-color:{navTheme === 'dark' ? '#1B2225' : '#fff'}" -->
<div
  class="nav-wrapper-container"
  style="background-color:{navTheme === 'dark' ? '#1B2225' : '#fff'}">
  <div
    class="nav-container"
    style="background-color:{navTheme === 'dark' ? '#1B2225' : '#fff'}">
    <div
      class="nav-inner-container"
      style="background-color:{navTheme === 'dark' ? '#1B2225' : '#fff'};
      border-bottom:{navTheme === 'dark' ? 'none' : '1px solid #ccc'};">
      <header>
        <nav>
          <!-- {#if navTheme === 'dark'}
                        <div transition:fade="{{delay: 0, duration: 3300}}" class="nav-logo"></div>
                    {/if} -->
          <div class="casey-logo-container">
            {#if navTheme === "dark"}
              <img
                style="position:absolute; left:0;"
                transition:fade
                src="/images/hero-logo-desktop.svg"
                alt="casey logo" />
            {:else}
              <img
                style="position:absolute; left:0;"
                transition:fade
                src="/images/cc-logo.svg"
                alt="casey logo" />
            {/if}
          </div>
          <svg
            id="mobile-cc-logo"
            xmlns="http://www.w3.org/2000/svg"
            width="44.008"
            height="40.54"
            viewBox="0 0 44.008 40.54">
            <g id="Group_5" data-name="Group 5" transform="translate(0 0.13)">
              <path
                id="Stroke_1"
                data-name="Stroke 1"
                d="M0,19.873v-.108C0,8.687,8.471,0,19.983,0c7.764,0,12.76,3.257,16.127,7.873l-7.927,6.136c-2.173-2.661-4.67-4.453-8.308-4.453-5.321,0-9.068,4.561-9.068,10.1v.109c0,5.7,3.747,10.154,9.068,10.154,3.964,0,6.3-1.847,8.579-4.616l7.928,5.647C32.8,35.892,27.964,39.53,19.6,39.53A19.3,19.3,0,0,1,0,19.873Z"
                transform="translate(6.919 0.374)"
                fill={navTheme === "dark" ? "#1B2225" : "#fff"}
                stroke={navTheme === "dark" ? "#fff" : "#1B2225"}
                stroke-miterlimit="10"
                stroke-width="1.01" />
              <path
                id="Fill_3"
                data-name="Fill 3"
                d="M0,19.873v-.108C0,8.687,8.471,0,19.983,0c7.764,0,12.76,3.257,16.127,7.873l-7.928,6.136c-2.172-2.661-4.67-4.453-8.308-4.453-5.321,0-9.067,4.561-9.067,10.1v.109c0,5.7,3.747,10.154,9.067,10.154,3.964,0,6.3-1.847,8.58-4.616l7.927,5.647C32.8,35.892,27.964,39.53,19.6,39.53A19.3,19.3,0,0,1,0,19.873"
                transform="translate(0 0.374)"
                fill={navTheme === "dark" ? "#fff" : "#1B2225"} />
            </g>
          </svg>

          <div
            class="nav-social-links {menuState}
            {navTheme === "dark" ? "" : "invert-col"}">
            <a
              href="https://twitter.com/caseycrawford"
              target="_blank"
              rel="noopener noreferrer">
              <img
                class="social-media-icon "
                src="/images/hero-twitter-icon.svg"
                alt="social-icon-twitter" />
            </a>
            <a
              href="https://www.instagram.com/caseyscrawford/"
              target="_blank"
              rel="noopener noreferrer">
              <img
                class="social-media-icon"
                src="/images/hero-instagram-icon.svg"
                alt="social-icon-instagram" />
            </a>
            <a
              href="https://www.facebook.com/CaseyCrawfordMovement/"
              target="_blank"
              rel="noopener noreferrer">
              <img
                class="social-media-icon"
                src="/images/hero-facebook-icon.svg"
                alt="social-icon-facebook" />
            </a>
            <a
              href="https://www.linkedin.com/in/caseycrawford/"
              target="_blank"
              rel="noopener noreferrer">
              <img
                class="social-media-icon"
                src="/images/hero-linkedin-icon.svg"
                alt="social-icon-linkedin" />
            </a>
          </div>
           <!-- New media kit updated -- SR  -->
          <a
            href="https://movementassets-all-web-ue1.s3.amazonaws.com/casey-crawford-media-kit/NewMediaKit.zip">

            <button
              class="media-kit-button"
              style={navTheme === "dark"
  ? "color:#1B2225;background:#fff"
  : "color:#fff;background:#1B2225"}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="27"
                height="27"
                viewBox="0 0 27 27">
                <g
                  id="Group_136"
                  data-name="Group 136"
                  transform="translate(-1155 -39)">
                  <g
                    id="Ellipse_3"
                    data-name="Ellipse 3"
                    transform="translate(1155 39)"
                    fill="none"
                    stroke={navTheme === "dark" ? "#1B2225" : "#fff"}
                    stroke-width="2">
                    <circle cx="13.5" cy="13.5" r="13.5" stroke="none" />
                    <circle cx="13.5" cy="13.5" r="12.5" fill="none" />
                  </g>
                  <path
                    id="Path_193"
                    data-name="Path 193"
                    d="M37.8,979.337a.568.568,0,0,0-.506.577V990.44l-3.31-3.532a.568.568,0,1,0-.834.772l4.26,4.553a.568.568,0,0,0,.834,0l4.26-4.553a.568.568,0,0,0-.834-.772l-3.239,3.452V979.914a.568.568,0,0,0-.577-.577Z"
                    transform="translate(1131.009 -933.337)"
                    fill={navTheme === "dark" ? "#1B2225" : "#fff"}
                    fill-rule="evenodd" />
                </g>
              </svg>
              MEDIA KIT
            </button>
          </a>

          <button on:click={toggleMenu} class="ham {menuState}">
            <span
              class="ham_line ham_line1"
              style="background-color:{navTheme === 'dark' ? '#fff' : '#1B2225'}" />
            <span
              class="ham_line ham_line2"
              style="background-color:{navTheme === 'dark' ? '#fff' : '#1B2225'}" />
            <span
              class="ham_line ham_line3"
              style="background-color:{navTheme === 'dark' ? '#fff' : '#1B2225'}" />
          </button>
        </nav>
      </header>
   </div>
</div>
</div>
